import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { NgxSmartModalComponent } from 'ngx-smart-modal';
import { TranslateService } from '@ngx-translate/core';
import { AccountAction } from '../account.service';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { User, UserService } from '../../core/user/user.service';
import { AgentService } from '../../core/agent/agent.service';
import { PageService } from '../../core/page.service';
import { ConversationsService } from '../../core/conversations/conversations.service';
import { InternalAnalyticsService, AnalyticsPage } from '../../core/internal-analytics.service';
import { Business, BusinessPhoneNumberType } from '../../core/business/business';
import { PhoneNumberPipe } from '../../shared/pipes/phone-number.pipe';

@Component({
  selector: 'rosie-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss'],
  standalone: false
})
export class ProfileComponent implements OnInit {
  inProgress: AccountAction = AccountAction.None;
  errorMessage = '';
  verificationForm: FormGroup;
  smsList = [];
  optInVerificationEnabled: FormControl;
  @ViewChild('clearRecordingModal') clearRecordingsModal: NgxSmartModalComponent;
  @ViewChild('smsModal') smsModal: NgxSmartModalComponent;
  @ViewChild('smsComplianceModal') smsComplianceModal: NgxSmartModalComponent;

  constructor(private user: UserService, private translate: TranslateService, private agent: AgentService, private page: PageService,
    private conversations: ConversationsService, private fb: FormBuilder, private analytics: InternalAnalyticsService, private phoneNumberPipe: PhoneNumberPipe) {
    this.page.initializePage(`Rosie - Account Settings`, AnalyticsPage.AccountProfile);
  }

  get userData(): User {
    return this.user.userData;
  }

  get isClearRecordingsInProgress(): boolean {
    return this.inProgress === AccountAction.ClearRecordings;
  }

  get hasSmsComplianceSupport(): boolean {
    return this.agent.isBlandProvider || this.agent.isLiveKitProvider;
  }

  get business(): Business {
    return this.agent.business;
  }

  get businessName(): string {
    return this.agent.business?.title;
  }

  get businessPhoneNumber(): string {
    return this.agent.business?.phoneNumbers?.find(phone => phone.type === BusinessPhoneNumberType.Main)?.number;
  }

  get optInTextPreview(): string {
    const formattedPhoneNumber = this.businessPhoneNumber ? this.phoneNumberPipe.transform(this.businessPhoneNumber) : '';
    return `${this.businessName}: Reply YES to receive info requested during call. May include promos. Msg & data rates may apply. STOP to cancel. ${formattedPhoneNumber ? `Need help? ${formattedPhoneNumber}.` : ''}`
  }

  get isOptInVerificationEnabled(): boolean {
    return this.business?.optInVerificationEnabled;
  }

  ngOnInit(): void {
    this.createSmsForm();
  }

  logout() {
    this.user.logout();
    this.analytics.reset();
  }

  getTranslation(translationKey: string): string {
    return this.translate.instant(`ACCOUNT.TABS.${translationKey?.toUpperCase()} `);
  }

  clearRecordingData() {
    this.inProgress = AccountAction.ClearRecordings;
    this.conversations.clearRecordings()
      .subscribe(() => {
        this.inProgress = AccountAction.None; this.clearRecordingsModal.close()
      }, () => this.inProgress = AccountAction.None);
  }

  fetchSmsList() {
    this.agent.getSMSList().subscribe((res: any) => {
      console.log(res)
      this.smsList = res?.map((sms) => sms.body) || [];
    });
  }

  saveSmsComplianceChanges() {
    this.inProgress = AccountAction.SaveSmsCompliance;
    this.agent.toggleOptInVerification(this.optInVerificationEnabled?.value)
      .subscribe(() => {
        this.inProgress = AccountAction.None;
        this.business.optInVerificationEnabled = this.optInVerificationEnabled?.value;
        this.smsComplianceModal.close();
      });
  }

  private createSmsForm() {
    this.agent.getVerification().subscribe((res: any) => {
      this.verificationForm = this.fb.group(res)
      this.verificationForm.get('dialpadVerification').valueChanges.subscribe((value) => {
        this.agent.toggleVerification(value, VerificationEnum.DialpadVerification).subscribe()
      });
      this.verificationForm.get('gbpVerification').valueChanges.subscribe((value) => {
        this.agent.toggleVerification(value, VerificationEnum.GBPVerification).subscribe()
      });
      this.verificationForm.get('sms').valueChanges.subscribe((value) => {
        this.agent.toggleVerification(value, VerificationEnum.SMS).subscribe()
      });
    });
    this.optInVerificationEnabled = new FormControl(this.business?.optInVerificationEnabled);
  }
}


export enum VerificationEnum {
  DialpadVerification = 'dialpad',
  GBPVerification = 'gbp',
  SMS = 'sms',
}